/**
 * 描述： 合同结构维护
 * 录入人： 张磊
 */
import request from '../request.js'


/**
 * 描述： 合同结构维护 - 新增或编辑合同结构维护
 * 接口管理员： 李开明
 * 参数：{}
 */
export const saveOrUpdateTemplateContract = function (data) {
    return request({
        url: 'templateContract/saveOrUpdateTemplateContract',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}


/**
 * 描述： 合同结构维护 - 查询合同结构
 * 接口管理员： 李开明
 * 参数：{}
 */
export const selectTemplateContract = function (data) {
    return request({
        url: 'templateContract/selectTemplateContract',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 合同结构维护 - 删除合同结构
 * 接口管理员： 李开明
 * 参数：{}
 */
export const deleteTemplateContract = function (data) {
    return request({
        url: 'templateContract/deleteTemplateContract',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 合同结构维护 - 修改是否生效的状态
 * 接口管理员： 李开明
 * 参数：{}
 */
export const setStatus = function (data) {
    return request({
        url: 'templateContract/setStatus',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 合同结构维护 - 上移或下移合同结构
 * 接口管理员： 李开明
 * 参数：{}
 */
export const upOrDownTemplateContract = function (data) {
    return request({
        url: 'templateContract/upOrDownTemplateContract',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}
